module.exports = "<md-dialog> <div layout-padding> <md-input-container ng-repeat=\"content in $ctrl.cmsContent\"> <label ng-if=\"content.language === 'en'\" translate>ENGLISH</label> <label ng-if=\"content.language === 'ru'\" translate>RUSSIAN</label> <textarea ng-model=content.text md-no-autogrow rows=7 style=width:500px></textarea> </md-input-container> </div> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>SAVE</span> </md-button> </md-dialog-actions> </md-dialog>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/hydromet/cms/cms-editor-dialog.html
 ** module id = 311
 ** module chunks = 0
 **/